export const PENDING_ENTITY_PROCESSOR_ROUTE = "pendingEntityProcessorRoute";

const isEntityProcessorRoute = (route) =>
  typeof route === "string" && route.startsWith("/entity-processor/");

const isUltimateAgentRoute = (route) =>
  typeof route === "string" &&
  route.startsWith("/ultimate-agent") &&
  !route.startsWith("/ultimate-agent/register") &&
  !route.startsWith("/ultimate-agent/invite/");

const isSupportedPostLoginRoute = (route) =>
  isEntityProcessorRoute(route) || isUltimateAgentRoute(route);

export const savePendingEntityProcessorRoute = (route) => {
  if (isSupportedPostLoginRoute(route)) {
    localStorage.setItem(PENDING_ENTITY_PROCESSOR_ROUTE, route);
  }
};

export const takePostLoginDestination = (fallbackRoute) => {
  const route = localStorage.getItem(PENDING_ENTITY_PROCESSOR_ROUTE);
  localStorage.removeItem(PENDING_ENTITY_PROCESSOR_ROUTE);

  return isSupportedPostLoginRoute(route) ? route : fallbackRoute;
};
